import React, { useEffect } from "react";
import PaginatedSelect from "../../components/ui/PaginatedSelect";
import useRelationTypeField from "./useRelationTypeField";

export default function RelationTypeSelect({ value, onChange, disabled, label = "Relation Type" }) {
  const { field, loadOptions } = useRelationTypeField();
  useEffect(() => { loadOptions(); }, [loadOptions]);
  return (
    <label className="block">
      <span className="mb-1.5 block text-sm font-medium text-slate-700">{label}</span>
      <PaginatedSelect
        value={value}
        onChange={onChange}
        options={field.options({ relation_type: value })}
        disabled={disabled || field.disabled}
        placeholder={field.placeholder}
      />
    </label>
  );
}
